var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offersToLoad > 0)?_c('div',{staticClass:"more-offers-loader"},[_c('a',{staticClass:"more-offers-loader__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('load')}}},[_vm._v("\n    Pokaż więcej ofert ("+_vm._s(_vm.offersToLoad)+")\n  ")]),_vm._v(" "),_c('Icon',{staticClass:"more-offers-loader__arrow",attrs:{"icon":"arr-right"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6dd59c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers-list/MoreOffersLoader.vue
// module id = 716
// module chunks = 1